import { isTest } from './env';

export const isFreshmarkEnabled = isTest;
